import { render, staticRenderFns } from "./PendingBadge.vue?vue&type=template&id=02a9c4b0"
import script from "./PendingBadge.vue?vue&type=script&lang=js"
export * from "./PendingBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports